"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popupLabel = void 0;
var _localization = require("@lt/localization");
var popupLabel = exports.popupLabel = _localization.i18n.t('touristsPicker.structure');